import React, { createContext, useContext } from 'react';

// Simplified theme context - just provides dark/light mode info
// The actual theme switching is handled by next-themes ThemeProvider

interface ThemeContextType {
  // Kept for backwards compatibility, always returns 'default'
  themeVariant: string;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

function useThemeVariant() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useThemeVariant must be used within a ThemeProvider');
  }
  return context;
}

export { useThemeVariant };

interface ThemeProviderProps {
  children: React.ReactNode;
}

function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <ThemeContext.Provider value={{ themeVariant: 'default' }}>
      {children}
    </ThemeContext.Provider>
  );
}

export { ThemeProvider };
